import React, { useRef } from 'react';
import './HomeHero.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from "swiper/modules";
import { useNavigate } from 'react-router-dom';

const Homehero = () => {
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.autoplay.start();
    }
  };
  
  return (
    <div className="home-hero d-flex" >
      <div className="container my-auto mb-xl-0 mb-0 mb-lg-auto">
        <div className='row align-items-center '>
          <div className='col-lg-5 py-lg-0 py-5 text-lg-start text-center'>
              <h2 className='hero-section-heading  ' style={{color:'#14609C'}}>PAIN RELIEF</h2>
              <h2 className='' style={{fontSize:"1.2rem"}}>AND ACCELERATED HEALING</h2>
              <p className='body-paragraph mb-1'>At Mobile Laser Therapy it is our philosophy that your time is valuable and we will make pain relief and healing easy for you using the Bioflex Professional Laser Therapy System</p>
              <p className='mb-2' style={{color:'black',fontWeight:"550",fontStyle:"italic"}}>A registered physiotherapist will come to your home to assess your condition and administer treatment</p>
              <img src='/images/icons/home-hero-content-icon.png' alt='arrow icon' className='d-lg-block d-none mt-2' style={{maxWidth:"200px"}} />
              <div className='d-flex algin-items-center justify-content-lg-start justify-content-center gap-3 mt-4'>
              <button className='genral-btn' onClick={()=>{window.open("tel:647-367-0067")}}>call us</button>
              <button className='genral-btn' onClick={()=>{window.open("mailto:info@mobilelasertherapy.ca")}}>email us</button>
              </div>
          </div>
          <div className='col-lg-7'>
          <Swiper
          ref={swiperRef}
          spaceBetween={50}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: true }}
          loop={true}
          modules={[Autoplay]}
          observer={true}
          observeParents={true}
          parallax={true}
          className=""
          id="articles-cards-slider"
        >

          {/* <SwiperSlide>
            <div className="row align-items-end ">
              <img src='/images/creatives/home-hero-1.png' alt='' />
            </div>
          </SwiperSlide> */}
          <SwiperSlide>
            <div className="row align-items-end">
              <img src='/images/creatives/home-hero-2.png' alt='' />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="row align-items-end">
              <img src='/images/creatives/home-hero-3.png' alt='' />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="row align-items-end">
              <img src='/images/creatives/home-hero-4.png' alt='' />
            </div>
          </SwiperSlide>

         
        </Swiper>
          </div>
        </div>
        
       
      </div>
    </div>
  );
};

export default Homehero;
